/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {BackfillProfilePhotoRequest} from '@cash-web/protos/squareup/cash/cashcustomerprofile/api/v1/backfill_profile_photo.pb'
import {BackfillProfilePhotoResponse} from '@cash-web/protos/squareup/cash/cashcustomerprofile/api/v1/backfill_profile_photo.pb'


export const backfillProfilePhoto = (request: BackfillProfilePhotoRequest, options?: CashRequestOptions) => post<BackfillProfilePhotoRequest, BackfillProfilePhotoResponse>("/2.0/cash/backfill-profile-photo", request, {...options, rejectOnError: true })